import { render } from "./bookmark_folders_menu_content.vue?vue&type=template&id=2ed606a6"
import script from "./bookmark_folders_menu_content.js?vue&type=script&lang=js"
export * from "./bookmark_folders_menu_content.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__